module.exports = __webpack_public_path__ + "8f8e6e442fbf8fa32574fb3cf65f0a74.MP3";